import { createAction, props } from '@ngrx/store';
import { TourLongDto } from '@api/rest';

export const loadTours = createAction(
  '[Tour/API] Load Tours'
);

export const loadToursSuccess = createAction(
  '[Tour/API] Load Tours Success',
  props<{ tours: TourLongDto[] }>()
);

export const loadToursFailure = createAction(
  '[Tour/API] Load Tours Failure',
  props<{ error: any }>()
);

export const getTour = createAction(
  '[Tour/API] Get Tour',
  props<{ id: string }>()
);

export const getTourSuccess = createAction(
  '[Tour/API] get Tour Success',
  props<{ tour: TourLongDto }>()
);

export const getTourFailure = createAction(
  '[Tour/API] Get Tour Failure',
  props<{ error: any }>()
);

export const setSelectedTour = createAction(
  '[Tour/API] Get Selected Tour',
  props<{ id: string }>()
);
